import React from 'react';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Services from './pages/Services/Services';
import Contact from './pages/Contact/Contact';
import Blog from './pages/Blog/Blog';
import BlogPost from './pages/Blog/BlogPost';
import OxfordGraduationDinner from './pages/Events/OxfordGraduationDinner';
import OxfordGraduationDinnerSuccess from './pages/Events/OxfordGraduationDinnerSuccess';
import NotFound from './pages/NotFound/NotFound';
const App = ({ url, blogPosts, blogPost }) => {
    // Simple client-side routing
    const path = url.split('?')[0]; // Remove query string
    // Route matching
    if (path === '/' || path === '') {
        return React.createElement(Home, null);
    }
    else if (path === '/about') {
        return React.createElement(About, null);
    }
    else if (path === '/services') {
        return React.createElement(Services, null);
    }
    else if (path === '/contact') {
        return React.createElement(Contact, null);
    }
    else if (path === '/blog' || path === '/blog/') {
        return React.createElement(Blog, { posts: blogPosts });
    }
    else if (path.startsWith('/blog/')) {
        return React.createElement(BlogPost, { post: blogPost });
    }
    else if (path === '/events/oxford_graduation_dinner_march_7_2026') {
        return React.createElement(OxfordGraduationDinner, null);
    }
    else if (path === '/events/oxford_graduation_dinner_march_7_2026/success') {
        return React.createElement(OxfordGraduationDinnerSuccess, null);
    }
    else {
        return React.createElement(NotFound, null);
    }
};
export default App;
